var _G;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { G, Path } from "react-native-svg";
function SvgIconAddEventOn(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 28,
    height: 28,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    fill: "#FFFF",
    stroke: "none",
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M19.997 2.226A4.182 4.182 0 0124.173 6.2l.005.208v7.395a.6.6 0 01-1.192.097l-.008-.097V6.407a2.982 2.982 0 00-2.806-2.976l-.175-.005H4.58a2.981 2.981 0 00-2.975 2.806l-.005.175v14.508a2.981 2.981 0 002.805 2.976l.175.005h9.904a.6.6 0 01.097 1.192l-.097.008H4.58a4.181 4.181 0 01-4.175-3.973L.4 20.915V6.407a4.181 4.181 0 013.971-4.176l.209-.005h15.417z"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M23.577 7.682a.6.6 0 01.097 1.193l-.097.007H1A.6.6 0 01.903 7.69l.098-.008h22.576zM18.605.4a.6.6 0 01.592.503l.008.097v3.424a.6.6 0 01-1.193.098l-.007-.098V1a.6.6 0 01.6-.6zM5.973.4a.6.6 0 01.592.503L6.573 1v3.424a.6.6 0 01-1.192.098l-.008-.098V1a.6.6 0 01.6-.6zM20 12.5a7.5 7.5 0 100 15 7.5 7.5 0 000-15zm0 1a6.5 6.5 0 110 13 6.5 6.5 0 010-13z"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M20 16.5a.5.5 0 01.492.41l.008.09v6a.5.5 0 01-.992.09L19.5 23v-6a.5.5 0 01.5-.5z"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M23 19.5a.5.5 0 01.09.992L23 20.5h-6a.5.5 0 01-.09-.992L17 19.5h6z"
  }))));
}
export default SvgIconAddEventOn;